/* eslint-disable */

import store from '@/store'
import router from '@/router'
import i18n from '@/i18n'
import { goldInfo, info } from '@/api/user'
import { CountUp } from 'countup.js'

var timer = null

// 定時回傳在線心跳 取得當下金幣數量
export function refreshGold(position) {
  if (store.getters.token != null) {
    if (position === 'multi_wallet')  {
      store.commit('SET_GOLD_INFO', null)

      info().then(response => {
        const walletInfo = response.data.data.walletInfo
        store.commit('SET_WALLET_INFO', walletInfo)

        const selectedWallet = walletInfo.find(wallet => wallet.wallet_type === store.state.app.selectedWallet.wallet_type)
        store.commit('SET_SELECTED_WALLET', selectedWallet)
      }).catch(error => {
        console.error('Socket, Failed to refresh wallet data:', error)
      })
    } else  {
      store.commit('SET_COMMISSION_GOLD', null)
    }

    goldInfo().then(response => {
      store.commit('SET_GOLD_INFO', response.data.data)
      store.commit('SET_GOLD_TOTAL', response.data.data)
      store.commit('SET_MAIN_GOLD', response.data.data)
      store.commit('SET_BONUS_GOLD', response.data.data)
      store.commit('SET_MAIN_POINT', response.data.data)
      store.commit('SET_MAIN_TURNOVER', response.data.data)
      store.commit('SET_POINTS', response.data.data)
      store.commit('SET_COMMISSION_GOLD', response.data.data)
    })
  }
}

// 正式環境線路不同 動態取url
export function getApiUrl() {
  // 決定api url
  if (store.getters.urlInfo.apiUrl) {
    return store.getters.urlInfo.apiUrl
  } else {
    return process.env.VUE_APP_BASE_API
  }
}

export function getGameApiUrl() {
  if (process.env.VUE_APP_ENV === 'production') {
    return process.env.VUE_APP_GAME
  } else {
    return process.env.VUE_APP_EVENT_API
  }
}

export function getEventApiUrl() {
  if (process.env.VUE_APP_EVENT_API === '') {
    return 'https://event.gitpush.vip'
  } else {
    return process.env.VUE_APP_EVENT_API
  }
}

export function getFullDomain() {
  const protocol = window.location.protocol;
  const host = window.location.host;

  return protocol + '//' + host + '/'
}

export function setErrorMessage(response, errors) {
  errors.clear()
  if (response !== undefined && response.status !== undefined && response.status === 406) {
    let lastError = i18n.t('Bao.sorry_for_the_error')
    Object.keys(response.data.data).forEach(key => {
      lastError = response.data.data[key][0]
      errors.add({
        field: key,
        msg: lastError
      })
    })
  }
}

export function toErrorPage(message) {
  store.commit('SET_ERROR_MESSAGE', message)
  router.push({ path: '/error' }, () => {
  })
}

export function toMaintainPage(message) {
  store.commit('SET_ERROR_MESSAGE', message)
  router.push({ path: '/maintain' }, () => {
  })
}

export function toForbiddenPage(message) {
  store.commit('SET_ERROR_MESSAGE', message)
  router.push({ path: '/forbidden' }, () => {
  })
}

export function copyText(message, url) {
  // 提取 URL 路徑部分（去掉域名）
  const pathOnly = extractPathFromUrl(url);
  
  // 檢測是否為真實手機設備
  const isMobile = detectMob();
  const isRealMobile = isMobile && !isDesktopSimulation();
  
  if (isRealMobile && navigator.share) {
    // 真實手機使用分享功能，但只分享路徑
    shareText(pathOnly);
  } else {
    // 電腦或模擬器直接複製
    fallbackCopy(pathOnly);
  }
}

function extractPathFromUrl(url) {
  try {
    // 如果是完整 URL
    if (url.startsWith('http://') || url.startsWith('https://')) {
      const urlObj = new URL(url);
      return urlObj.pathname.replace(/^\//, '');
    }
    // 如果是相對路徑但以 / 開頭
    if (url.startsWith('/')) {
      return url.replace(/^\//, '');
    }
    // 如果已經是純路徑
    return url;
  } catch (error) {
    console.warn('URL parsing error:', error);
    return url;
  }
}

// 檢測是否為桌面模擬器（而非真實手機）
function isDesktopSimulation() {
  // 檢查螢幕大小 - 真實手機通常不會有太大的螢幕
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  
  // 檢查 devicePixelRatio - 模擬器通常比較特殊
  const pixelRatio = window.devicePixelRatio || 1;
  
  // 檢查觸摸支援 - 桌面模擬器可能會有差異
  const maxTouchPoints = navigator.maxTouchPoints || 0;
  
  // 如果螢幕太大，可能是桌面模擬器
  if (screenWidth > 1920 || screenHeight > 1080) {
    return true;
  }
  
  // 檢查 user agent 中的模擬器特徵
  const userAgent = navigator.userAgent.toLowerCase();
  const isChrome = userAgent.includes('chrome');
  const isSafari = userAgent.includes('safari') && !userAgent.includes('chrome');
  
  // Chrome 開發者工具模擬器通常會有特殊特徵
  if (isChrome && (
    userAgent.includes('headlesschrome') ||
    userAgent.includes('chrome-lighthouse') ||
    maxTouchPoints === 0
  )) {
    return true;
  }

  return false;
}

// 使用分享功能（僅限真實手機）
function shareText(text) {
  if (navigator.share) {
    navigator.share({
      text: text,  // 只分享路徑文字，不包含 URL
      title: 'Share successful'
    }).then(() => {
      console.log('Share successful');
    }).catch(err => {
      console.error('Share failed:', err);
      // 如果分享失敗，降級到直接複製
      fallbackCopy(text);
    });
  } else {
    // 如果不支援分享，降級到直接複製
    fallbackCopy(text);
  }
}

function fallbackCopy(text) {
  // 檢測是否為 Safari 並且是移動設備
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isMobile = detectMob();
  
  // 優先使用現代 Clipboard API，但要避免 Safari 移動版的分享問題
  if (navigator.clipboard && navigator.clipboard.writeText && (!isSafari || !isMobile)) {
    navigator.clipboard.writeText(text)
      .then(() => {
        showNotice(i18n.t('Bao.copy_ok'));
      })
      .catch(err => {
        console.error('Clipboard API error:', err);
        legacyCopy(text);
      });
  } else {
    // Safari 移動版或舊瀏覽器使用 fallback
    legacyCopy(text);
  }
}

function legacyCopy(text) {
  // 檢測是否為 Safari
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  
  if (isSafari) {
    // Safari 專用處理
    safariCopy(text);
  } else {
    // 其他瀏覽器使用原有方法
    standardLegacyCopy(text);
  }
}

function safariCopy(text) {
  // 創建一個不可見的 textarea
  const textarea = document.createElement('textarea');
  textarea.value = text;
  
  // 設置樣式確保完全不可見且不影響布局
  textarea.style.position = 'fixed';
  textarea.style.top = '-9999px';
  textarea.style.left = '-9999px';
  textarea.style.width = '1px';
  textarea.style.height = '1px';
  textarea.style.opacity = '0';
  textarea.style.border = 'none';
  textarea.style.outline = 'none';
  textarea.style.boxShadow = 'none';
  textarea.style.background = 'transparent';
  textarea.style.resize = 'none';
  textarea.readOnly = false;
  
  // 添加到 body
  document.body.appendChild(textarea);
  
  // 給 textarea 焦點
  textarea.focus();
  textarea.select();
  
  // 針對 iOS Safari 的特殊處理
  if (navigator.userAgent.match(/ipad|iphone/i)) {
    // 設置選取範圍
    textarea.setSelectionRange(0, textarea.value.length);
    
    // 創建 Range 和 Selection（額外保險）
    const range = document.createRange();
    range.selectNodeContents(textarea);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }
  
  // 短暫延遲確保選取完成
  setTimeout(() => {
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        showNotice(i18n.t('Bao.copy_ok'));
      } else {
        console.warn('execCommand returned false in Safari');
        // 嘗試使用 Clipboard API 作為後備
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text)
            .then(() => showNotice(i18n.t('Bao.copy_ok')))
            .catch(err => console.error('Backup clipboard error:', err));
        }
      }
    } catch (err) {
      console.error('Safari execCommand error:', err);
      // 嘗試使用 Clipboard API 作為後備
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text)
          .then(() => showNotice(i18n.t('Bao.copy_ok')))
          .catch(err => console.error('Backup clipboard error:', err));
      }
    }
    
    // 清理
    document.body.removeChild(textarea);
  }, 10);
}

function standardLegacyCopy(text) {
  const span = document.createElement('span');
  span.textContent = text;
  
  // 為了避免樣式干擾
  span.style.whiteSpace = 'pre';
  span.style.position = 'absolute';
  span.style.left = '-9999px';
  
  document.body.appendChild(span);
  
  // 使用 Selection + Range
  const range = document.createRange();
  range.selectNodeContents(span);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
  
  try {
    const successful = document.execCommand('copy');
    if (successful) {
      showNotice(i18n.t('Bao.copy_ok'));
    } else {
      console.warn('execCommand returned false');
    }
  } catch (err) {
    console.error('execCommand error:', err);
  }
  
  // 清理
  selection.removeAllRanges();
  document.body.removeChild(span);
}

export function showNotice(message, func, close, isMessageLabel, isUseOKText) {
  const data = {
    message: message,
    func: func,
    close: close === undefined ? true : close,
    isMessageLabel: isMessageLabel === undefined ? false : isMessageLabel,
    isUseOKText: isUseOKText === undefined ? false : isUseOKText
  }
  store.commit('SET_NOTICE_MESSAGE', data)
}

export function showRequest(message, func) {
  const data = {
    message: message,
    func: func
  }
  store.commit('SET_REQUEST_MESSAGE', data)
}

export function showToast(message, func, close, isMessageLabel) {
  const data = {
    message: message,
    func: func,
    close: close === undefined ? true : close,
    isMessageLabel: isMessageLabel === undefined ? false : isMessageLabel
  }
  store.commit('SET_TOAST_MESSAGE', data);
}

export function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

export function forceApp(currentRouteName, forceSetting) {
  if ((currentRouteName !== 'Register' && currentRouteName !== 'Share' && currentRouteName !== 'Error' && currentRouteName !== 'Critical') && forceSetting === 1 && detectMob() && !notAppPage()) {
    return true
  } else {
    return false
  }
}

export function newWindows(dataObject) {
  var newWindow = null
  if (dataObject.open_type === 'new') {
    return '_blank'
  }

  if (dataObject.open_type === 'self') {
    return '_self'
  }
}

export async function loadDynamicCss() {
  let currentTheme = localStorage.getItem('theme')
  if (!currentTheme || currentTheme !== process.env.VUE_APP_THEME) {
    currentTheme = process.env.VUE_APP_THEME
    localStorage.setItem('theme', currentTheme)
  }
  store.commit('SET_THEME', currentTheme);
  
  // 動態載入主題 CSS 變數 - 必須先成功加载才能继续
  if (currentTheme) {
    try {
      await import(`@/assets/${currentTheme}/variables.css`)
    } catch (error) {
      console.error(`Failed to load theme variables for ${currentTheme}:`, error)

      try {
        const fallbackTheme = 'theme_gold'
        console.warn(`Attempting to load fallback theme: ${fallbackTheme}`)
        await import(`@/assets/${fallbackTheme}/variables.css`)

        localStorage.setItem('theme', fallbackTheme)
        store.commit('SET_THEME', fallbackTheme)
      } catch (fallbackError) {
        console.error('Failed to load fallback theme variables:', fallbackError)
        return
      }
    }
  }
  
  if (window.location.pathname.startsWith('/affiliate')) {
    const cssFiles = ['proxy_style.css']
    await Promise.all(cssFiles.map(file => import('@/assets/css/minor_css/proxy/' + file)))
    return;
  } else {
    const cssFiles = ['main.css','footer.css']
    await Promise.all(cssFiles.map(file => import('@/assets/css/' + file)))
    await import('@/assets/css/style.css')
  }
}

export function handleTokenUrl(urlString, token) {
  const url = new URL(urlString)
  const params = new URLSearchParams(url.search)
  params.delete('token')
  if (token) {
    params.append('token', token)
  } else {
    params.append('token', '')
  }
  return `${url.origin}${url.pathname}?${params.toString()}`
}

export function getSumFloatNum(dataList, resultDigit) {
  const maxDecimalLength = Math.max(...dataList.map(numStr => (numStr.split('.')[1] || '').length))
  const sum = dataList.reduce((total, numStr) => {
      const [integerPart, decimalPart] = numStr.split('.')
      const paddedDecimalPart = (decimalPart || '').padEnd(maxDecimalLength, '0')
      return total + Number(integerPart + paddedDecimalPart)
  }, 0)
  const sumWithDecimal = (sum / Math.pow(10, maxDecimalLength)).toFixed(resultDigit)

  return sumWithDecimal
}

export function setCurrencySymbol() {
  let currency = process.env.VUE_APP_CURRENCY
  if (currency === 'JPY') {
    store.commit('SET_CURRENCY', '¥')
  } else {
    store.commit('SET_CURRENCY', '$')
  }
}

export function isCrossDay(currentTimeStamp, storedTimeStamp) {
  const currentDay = new Date(currentTimeStamp * 1000).getDate();
  const storedDay = new Date(storedTimeStamp * 1000).getDate();
  return currentDay !== storedDay; // false代表還是同一天
}

export function getThemeImagePath(imageName) {
  let theme = process.env.VUE_APP_THEME || 'theme_gold'
  return require(`@/assets/${theme}/images/${imageName}`)
}

export function getWalletImagePath(wallet) {
  if (!wallet) {
    return getThemeImagePath('default-crypto.svg')
  }

  if (wallet.currency === 'JPY') {
    if (wallet.wallet_type === 'bonus') {
      return getThemeImagePath('icon_bonus.svg')
    } else {
      return getThemeImagePath('icon_jpy.svg')
    }
  }

  // Define supported crypto currencies
  const supportedCryptos = [
    'JPY', 'UBD', 'BONUS', 'USDT', 'LTC', 'XRP', 'BTC', 'ETH',
    'DOGE', 'BCH', 'TRX', 'BNB', 'USDC', 'SHIB', 'TETH', 'ADA'
  ].map(c => c.toLowerCase())

  // Make sure currency is a string and convert to lowercase
  const currency = wallet.currency ? String(wallet.currency).toLowerCase() : ''

  // Check if the currency is supported
  if (supportedCryptos.includes(currency)) {
    return getThemeImagePath(`crypto-${currency}.svg`)
  } else {
    // Return default image for unsupported cryptocurrencies
    return getThemeImagePath('default-crypto.svg')
  }
}

export function getWalletBalance(wallet) {
  if (!wallet) return '0'

  const balance = parseFloat(wallet.balance) || 0

  if (wallet.currency === 'JPY') {
    // JPY: 無條件捨去到兩位小數
    const truncated = Math.floor(balance * 100) / 100
    const isInteger = truncated % 1 === 0
    return isInteger
      ? truncated.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : truncated.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else {
    // 其他幣別：顯示到小數點以下第六位,無條件捨去後面位數
    const truncated = Math.floor(balance * 1e6) / 1e6
    return truncated.toFixed(6)
  }
}

function getWalletName(wallet) {
  if (process.env.VUE_APP_THEME === "theme_blue" && wallet.wallet_type !== 'bonus' && wallet.currency === "USD") {
    return "UBD"
  }else {
    return wallet.wallet_type === 'bonus' ? 'BONUS' : wallet.currency
  }
}

export function getFilteredWalletInfo(walletInfo, brandInfo) {
  if (!walletInfo || walletInfo.length === 0) {
    console.log('filteredWalletInfo: returning empty array - wallet not initialized or no data')
    return []
  }

  const currencyOrder = [
    'JPY', 'UBD', 'BONUS', 'USDT', 'LTC', 'XRP', 'BTC', 'ETH',
    'DOGE', 'BCH', 'TRX', 'BNB', 'USDC', 'SHIB', 'TETH', 'ADA'
  ]

  const completeWallets = []

  walletInfo.forEach(wallet => {
    if (process.env.VUE_APP_THEME === "theme_blue" && wallet.wallet_type === 'commission') return // UB 忽略 commission 類型
    completeWallets.push({
      wallet_type: wallet.wallet_type,
      currency: wallet.currency,
      balance: wallet.balance,
      name: getWalletName(wallet)
    })
  })

  if (brandInfo && brandInfo.wallet_types) {
    brandInfo.wallet_types.forEach(type => {
      if (process.env.VUE_APP_THEME === "theme_blue" && type.wallet_type === 'commission') return // UB 忽略 commission 類型

      const exists = completeWallets.some(w =>
        w.wallet_type === type.wallet_type
      )
      if (!exists) {
        completeWallets.push({
          wallet_type: type.wallet_type,
          currency: type.currency,
          balance: '0',
          name: getWalletName(type)
        })
      }
    })

    let jpyIndex = completeWallets.findIndex(w => w.currency === 'JPY' && w.wallet_type !== 'main' && w.wallet_type !== 'bonus')
    while (jpyIndex !== -1) {
      completeWallets.splice(jpyIndex, 1)
      jpyIndex = completeWallets.findIndex(w => w.currency === 'JPY' && w.wallet_type !== 'main' && w.wallet_type !== 'bonus')
    }
  }

  const walletsWithBalance = completeWallets.filter(wallet => {
    const balance = parseFloat(wallet.balance) || 0
    return balance >= 0
  })

  return walletsWithBalance.sort((a, b) => {
    const indexA = currencyOrder.indexOf(String(a.name))
    const indexB = currencyOrder.indexOf(String(b.name))

    if (indexA !== -1 && indexB !== -1) return indexA - indexB
    if (indexA !== -1) return -1
    if (indexB !== -1) return 1
    return String(a.name).localeCompare(String(b.name))
  })
}

// 检查 LiveChat 是否可用
export function isLiveChatAvailable() {
  return typeof LiveChatWidget !== 'undefined' && LiveChatWidget !== null;
}

// 設置 LiveChatWidget 用戶資料
export function setLiveChatWidget(username, email) {
  if (!isLiveChatAvailable()) {
    console.warn('LiveChat is not available');
    return;
  }

  try {
    setTimeout(() => {
      LiveChatWidget.call('set_customer_name', username);
      LiveChatWidget.call('set_customer_email', email);
      LiveChatWidget.call('maximize');
    }, 100);
  } catch (error) {
    console.warn('LiveChat operation error:', error);
  }
}

// 設置 LiveChatWidget Session Variables
export function setSessionVariables(user, userInfo, vipInfo, dateFormatter) {
  const {
    is_pass_KYC,
    first_deposit_amount,
    second_deposit_amount,
    third_deposit_amount,
    birthday,
    vip_last_updated_at,
    last_withdrawal_amount,
    last_withdrawal_updated_at,
    name,
    vl
  } = userInfo;

  const kycStatusMap = {
    0: 'KYC_NONE',
    1: 'KYC_PASS',
    2: 'KYC_PROGRESS',
  };

  const isPassKYC = kycStatusMap[is_pass_KYC];

  const sessionVars = {
    kyc: isPassKYC,
    dep1: first_deposit_amount,
    dep2: second_deposit_amount,
    dep3: third_deposit_amount,
    vip: vipInfo.currentVipName,
    birthday,
    vip_last_updated_at: vip_last_updated_at === 0 ? 0 : dateFormatter(vip_last_updated_at),
    last_withdrawal_amount,
    last_withdrawal_updated_at: last_withdrawal_updated_at === 0 ? 0 : dateFormatter(last_withdrawal_updated_at),
    name: name,
    main_balance: user.mainGold,
    bonus_balance: user.bonusGold,
    risk: vl,
  };

   // 處理 walletInfo 中的 balance
  const formatJPY = (amount) => {
    const truncated = Math.floor(amount * 100) / 100;
    const isInteger = truncated % 1 === 0;
    return isInteger
      ? truncated.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : truncated.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const formatOther = (amount) => {
    const truncated = Math.floor(amount * 1e6) / 1e6;
    return truncated.toFixed(6);
  };

  if (Array.isArray(user.walletInfo)) {
    let jpyTotal = 0;

    user.walletInfo.forEach(wallet => {
      const { wallet_type, currency, balance } = wallet;
      const numericBalance = parseFloat(balance);

      if (!isNaN(numericBalance) && numericBalance > 0) {
        if (currency === 'JPY' && (wallet_type === 'main' || wallet_type === 'bonus')) {
          jpyTotal += numericBalance;

        } else if (currency !== 'JPY') {
          sessionVars[currency] = formatOther(numericBalance);
        }
      }
    });

    if (jpyTotal > 0) {
      sessionVars['JPY'] = formatJPY(jpyTotal);
    }
  }

  LiveChatWidget.call('set_session_variables', sessionVars);
}

// 處理 HelpCenter 的連結邏輯
export function handleHelpCenterLink(isGuest, banner, user, userInfo, vipInfo, dateFormatter) {
  let formattedLink = banner.link ? banner.link : banner.url;

  if (isGuest) {
    if (banner.open_type === '_iframe') {
      setLiveChatWidget('guest', 'guest@katsuwin.io');
    } else {
      const url = new URL(formattedLink);
      formattedLink = `${url.origin}${url.pathname}`;
      window.open(formattedLink, banner.open_type);
    }
  } else {
    const { username, email, is_pass_KYC, first_deposit_amount, second_deposit_amount, third_deposit_amount } = userInfo;

    if (banner.open_type === '_iframe') {
      setSessionVariables(user, userInfo, vipInfo, dateFormatter);
      setLiveChatWidget(username, email);
    } else {
      const encodedUsername = encodeURIComponent(username);
      const encodedEmail = encodeURIComponent(email);
      const kycStatusMap = {
        0: 'KYC_NONE',
        1: 'KYC_PASS',
        2: 'KYC_PROGRESS',
      };
      const kycStatus = kycStatusMap[is_pass_KYC];

      formattedLink = formattedLink
        .replace('{NAME}', encodedUsername)
        .replace('{EMAIL}', encodedEmail)
        .replace('&amp;', '&')
        .replace('{K}', kycStatus)
        .replace('{D}', `${first_deposit_amount},${second_deposit_amount},${third_deposit_amount}`);
      window.open(formattedLink, banner.open_type);
    }
  }
}

export function initializeCountUp(elementId, value, options = {}) {
  if (!elementId || !value) return;

  const defaultOptions = {
    useEasing: true,
    useGrouping: true,
    separator: '',
    decimal: ',',
    suffix: '',
    startVal: 0,
    duration: 2.5,
  };
  const mergedOptions = { ...defaultOptions, ...options };
  const demo = new CountUp(elementId, value, mergedOptions);

  if (!demo.error) {
    demo.start();
  } else {
    console.error(demo.error);
  }
}

export function updateCountUp(elementId, newValue, options) {
  initializeCountUp(elementId, newValue, options);
}

export function performKYCCheck(router, type, useReplace = false) {
  let permissionInfo = store.getters.permissionInfo || store.state.permissionInfo
  const memberInfo = store.getters.memberInfo || store.state.memberInfo
  
  const kycMapping = {
    1: 'enable_KYC_withdrawal_bank',
    2: 'enable_KYC_withdrawal_ewallet',
    3: 'enable_KYC_withdrawal_cryptocurrency'
  }

  const kycKey = kycMapping[type]
  // 檢查是否需要 KYC
  if (kycKey && permissionInfo[kycKey] && memberInfo.is_pass_KYC !== 1) {
    const routerMethod = useReplace ? 'replace' : 'push'
    showNotice(
      i18n.t('Bao.KYC_check'),
      () => {
        if (memberInfo.address && 
            memberInfo.email_validate === 1 && 
            memberInfo.phone_validate === 1 && 
            memberInfo.withdrawal_pass === 'has set') {
          router[routerMethod]({ path: '/user/KYC' })
        } else {
          router[routerMethod]({ path: '/user/edit' })
        }
      }
    )
    return true // 需要 KYC，已處理跳轉
  }
  
  return false // 不需要 KYC
}